import { api } from '../../../shared/lib/axios';
import { openAuthenticatedFile } from '../../../shared/lib/files';

export interface PrestadorCadastroData {
  userId: string;
  name: string;
  email: string;
  phone: string;
  role: string;
  employmentType: string | null;
}

export interface PatchCadastroPayload {
  phone?: string;
  email?: string;
}

export interface ChangeLogEntry {
  id: string;
  field: string;
  oldValue: string | null;
  newValue: string | null;
  changedAt: string;
}

export interface HistoricoResponse {
  data: ChangeLogEntry[];
  total: number;
  page: number;
  limit: number;
}

export async function getPrestadorCadastro(): Promise<PrestadorCadastroData> {
  const { data } = await api.get<PrestadorCadastroData>('/prestador/cadastro');
  return data;
}

export async function patchPrestadorCadastro(
  payload: PatchCadastroPayload,
): Promise<PrestadorCadastroData> {
  const { data } = await api.patch<PrestadorCadastroData>('/prestador/cadastro', payload);
  return data;
}

export async function getPrestadorHistorico(
  page = 1,
  limit = 20,
): Promise<HistoricoResponse> {
  const { data } = await api.get<HistoricoResponse>('/prestador/cadastro/historico', {
    params: { page, limit },
  });
  return data;
}

// ─── Contratos ───────────────────────────────────────────────────────────────

export interface ContratoItem {
  id: string;
  tipo: string;
  numero: string;
  status: string;
  dataInicio: string | null;
  dataVigencia: string | null;
  cliente: string | null;
  projetos: string | null;
  documentoUrl: string | null;
  uploadedByPrestadorUrl: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ContratosResponse {
  data: ContratoItem[];
  total: number;
  page: number;
  limit: number;
}

export async function getPrestadorContratos(
  page = 1,
  limit = 20,
  status?: string,
): Promise<ContratosResponse> {
  const { data } = await api.get<ContratosResponse>('/prestador/contratos', {
    params: { page, limit, ...(status ? { status } : {}) },
  });
  return data;
}

export async function downloadContrato(id: string): Promise<void> {
  await openAuthenticatedFile(`/api/prestador/contratos/${id}/download`);
}

export async function uploadContratoDoc(id: string, file: File): Promise<ContratoItem> {
  const form = new FormData();
  form.append('file', file);
  const { data } = await api.post<ContratoItem>(`/prestador/contratos/${id}/upload`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}
